export const questionData = [
    {
      id: "1",
      question: "Сколько стоит  переход на систему “Атлас”?",
      answer: "Установка, наладка, обучение сотрудников - бесплатно. Также в подарок нашим клиентам входит бесплатный тестовый период продолжительностью 30 дней. В дальнейшем стоимость обслуживания и техподдержки составит 4 тыс. рублей в месяц с одной аптеки."
    },
    {
        id: "2",
        question: "Для кого подойдёт система “Атлас”?",
        answer: "Среди наших клиентов есть и отдельные частные аптеки, и небольшие сети аптек и аптечных пунктов. Облачный сервер позволяет не предъявлять высокие требования к оборудованию, так как все данные системы хранятся на удалённом сервере."
      },
      {
        id: "3",
        question: "Входит ли в функционал системы работа с ИС «Маркировка»? Нужно ли за это дополнительно платить?",
        answer: "Согласно приказу Минздрава №866, аптеки должны иметь программу, обеспечивающую информационное взаимодействие с ФГИС МДЛП, рабочие места, оснащенные персональными компьютерами, устройствами считывания специальной маркировки, а также ключами электронной подписи (ЭП). Комплекс «Атлас» учитывает все эти требования. Дополнительно платить за это не нужно."
      },
      {
        id: "4",
        question: "Работает ли техподдержка по вечерам и в выходные дни?",
        answer: "Да, мы готовы помогать вам в любое время, 24/7. Наша цель - чтобы вам спокойно работалось."
      },
      {
        id: "5",
        question: "Можно ли применить систему “Атлас” для автоматизации аптечной сети?",
        answer: "Конечно! Наше решение позволяет работать как одиночным точкам, так и крупным аптечным сетям."
      } 
    
]